"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplementationRuleSectionsSchema = void 0;
exports.parseImplementationRuleSections = parseImplementationRuleSections;
exports.computeImplementationRuleSectionsContentHash = computeImplementationRuleSectionsContentHash;
const z = require("zod");
const implementation_rules_1 = require("./implementation-rules");
exports.ImplementationRuleSectionsSchema = implementation_rules_1.ImplementationRuleSectionSchema.array().superRefine((sections, context) => {
    const seenSectionIds = new Set();
    const seenSlugs = new Set();
    const seenRuleIds = new Set();
    for (const [sectionIndex, section] of sections.entries()) {
        if (seenSectionIds.has(section.sectionId)) {
            context.addIssue({
                code: z.ZodIssueCode.custom,
                path: [sectionIndex, 'sectionId'],
                message: `Duplicate implementation-rule section id: ${section.sectionId}`,
            });
        }
        seenSectionIds.add(section.sectionId);
        if (seenSlugs.has(section.sectionSlug)) {
            context.addIssue({
                code: z.ZodIssueCode.custom,
                path: [sectionIndex, 'sectionSlug'],
                message: `Duplicate implementation-rule section slug: ${section.sectionSlug}`,
            });
        }
        seenSlugs.add(section.sectionSlug);
        for (const [ruleIndex, rule] of section.rules.entries()) {
            if (seenRuleIds.has(rule.id)) {
                context.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: [sectionIndex, 'rules', ruleIndex, 'id'],
                    message: `Duplicate implementation-rule id: ${rule.id}`,
                });
            }
            seenRuleIds.add(rule.id);
        }
    }
});
function parseImplementationRuleSections(value) {
    return value === undefined ? [] : exports.ImplementationRuleSectionsSchema.parse(value);
}
async function computeImplementationRuleSectionsContentHash(sections) {
    const byCodePoint = (left, right) => left < right ? -1
        : left > right ? 1
            : 0;
    const projection = [...sections]
        .sort((left, right) => byCodePoint(left.sectionId, right.sectionId))
        .map((section) => ({
        sectionId: section.sectionId,
        sectionSlug: section.sectionSlug,
        rules: [...section.rules]
            .sort((left, right) => byCodePoint(left.id, right.id))
            .map((rule) => ({
            id: rule.id,
            text: rule.text,
            citations: rule.citations.map((citation) => ({
                citationText: citation.citationText,
                fileId: citation.fileId,
                elementIndexes: citation.elementIndexes,
                pageNumber: citation.pageNumber,
                citedText: citation.citedText,
                description: citation.description,
            })),
        })),
    }));
    const bytes = new TextEncoder().encode(JSON.stringify(projection));
    const digest = await globalThis.crypto.subtle.digest('SHA-256', bytes);
    const hexadecimal = Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
    return `sha256:${hexadecimal}`;
}
//# sourceMappingURL=canonical-implementation-rules.js.map